import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/login-background.jpg'


const _withScopeId = n => (_pushScopeId("data-v-0ef6cac2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row w-100 h-100 noselect" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 col-md-6 col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "background-image",
    class: "d-none d-lg-block d-sm-block",
    src: _imports_0
  })
], -1))
const _hoisted_3 = {
  class: "col-lg-4 col-md-6 col-sm-8 z-2",
  style: {"position":"relative"},
  id: "right-panel"
}
const _hoisted_4 = {
  key: 0,
  class: "result-message"
}
const _hoisted_5 = {
  key: 1,
  class: "error-message"
}
const _hoisted_6 = { class: "input-group-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-block shadow-none login-button" }, " Reset Password ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    "data-v-5ff415d5": "",
    src: "data:image/png;base64,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",
    draggable: "false",
    class: "copyright"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_img = _resolveComponent("b-img")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_input_group_prepend = _resolveComponent("b-input-group-prepend")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_input_group = _resolveComponent("b-input-group")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_b_form, {
        onSubmit: _ctx.onResetPassword,
        style: {"margin-top":"8rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_img, {
            class: "pb-5 w-50",
            src: require('@/assets/LG_MetaChef.svg')
          }, null, 8, ["src"]),
          (_ctx.resettingPassword)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Your new password has been set! "))
            : _createCommentVNode("", true),
          (_ctx.noCode)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Invalid code. Please click the link in the email. "))
            : _createCommentVNode("", true),
          _createVNode(_component_b_input_group, { class: "click-cursor" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_input_group_prepend, { class: "input-noborder" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_font_awesome_icon, {
                      size: "2x",
                      icon: ['fa', 'lock']
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_b_form_input, {
                modelValue: _ctx.form.password,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password) = $event)),
                type: "password",
                class: "login-input",
                size: "lg",
                placeholder: "New Password",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_b_input_group, { class: "pt-4 click-cursor" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _hoisted_8
    ])
  ]))
}